import React, { Component } from "react";
import TablePelayanan from "./TablePelayanan.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import API from "../../apiService.js";
import { showLoading, toast } from "view/component/Alert.js";
class Pelayanan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: {},
      filteredDatas: [],
      isLoading: true,
      room: [],
      frDate: JSON.parse(localStorage.getItem("SearchDate"))
        ? JSON.parse(localStorage.getItem("SearchDate")).date.frDate
        : moment(new Date()).format("YYYY-MM-DD"),
      enDate: JSON.parse(localStorage.getItem("SearchDate"))
        ? JSON.parse(localStorage.getItem("SearchDate")).date.enDate
        : moment(new Date()).format("YYYY-MM-DD"),
      keyword: "",
      parent: false,
      limit: "10",
      sort: "ASC",
      served: false,
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
        ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
        : "",
      room_id: ""
    };

    this.checkHandler = this.checkHandler.bind(this);
  }

  componentDidMount() {
    this.fetchDatas();
    this.getRoom();
  }

  getRoom = async () => {
    const res = await API.get("/management/room/read");
    if (res.code === 200) {
      this.setState({
        room: res.data,
      });
    }
  };

  fetchDatas = async () => {
    // this.setState({
    //   datas: {...dummy.data, data: dummy.data.data.filter(v => v.inpatient.inpatient_rooms.length)},
    //   isLoading: false,
    // });
    let param = {
      keyword: this.state.keyword,
      frDate: this.state.frDate,
      enDate: this.state.enDate,
      limit: this.state.limit,
      sort: this.state.sort,
      served: this.state.served,
      parent: this.state.parent,
      has_room: 1,
      room_id: this.state.room_id
    };
    showLoading("Mencari Data");
    const res = await API.post("/registration/inpatient/read", param);

    if (res.code === 200) {
      toast({ status: "success", text: "Data Ditemukan" });
      this.setState({
        datas: {...res.data, data: res.data.data.filter(v => v.inpatient.inpatient_rooms.length)},
        isLoading: false,
      });
      localStorage.setItem(
          "SearchDate",
          JSON.stringify({
            date: { frDate: this.state.frDate, enDate: this.state.enDate },
            room: this.state.keyword.roomId,
          })
      );
    } else {
      toast({ status: "error", text: "Data tidak ditemukan" });
      this.setState({
        datas: [],
        isLoading: false,
      });
    }
  };

  onChangeKeyword = (e) => {
    const param = e.target.value;
    this.setState({
      keyword: param,
    });
  };

  checkHandler = (checked) => {
    if (checked) {
      this.setState(
        {
          served: true,
        },
        () => this.fetchDatas()
      );
    } else {
      this.setState(
        {
          served: false,
        },
        () => this.fetchDatas()
      );
    }
  };

  patientFilter = (data) => {
    if (!data) return [];
    return data.filter((value) => {
      return value.served === false;
    });
  };

  render() {
    const frDate = moment(this.state.frDate).toDate();
    const enDate = moment(this.state.enDate).toDate();
    const { filteredDatas, isLoading } = this.state;

    const rooms = this.state.room.map((room) => (
        <option key={room.id} value={room.id}>
          {room.name}
        </option>
    ));

    return (
      <div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-header border-0">
                  <div className="row">
                    <div className="col-md-2">
                      <h3>Kata Kunci</h3>
                    </div>

                    <input
                      className="form-control col-md-10"
                      name="katakunci"
                      placeholder="no RM/nama"
                      type="text"
                      onChange={this.onChangeKeyword}
                    />
                  </div>
                  <div className="row" style={{ marginTop: "2%" }}>
                    <div className="col-md-2">
                      <h3 className="p-0 mt-2">Ruangan</h3>
                    </div>
                    <select
                        className="form-control col-md-2"
                        onChange={(event) => {
                          let id = event.target.value;
                          this.setState({ room_id : id})
                        }}
                        value={this.state.room_id}
                    >
                      <option value="">Pilih Ruangan</option>
                      {rooms}
                    </select>
                  </div>
                  <div className="row" style={{ marginTop: "2%" }}>

                    <div className="col-md-2">
                      <h3 className="p-0 mt-2">Tanggal Masuk</h3>
                    </div>
                    <DatePicker
                      className="form-control col-md-12"
                      selected={frDate}
                      onChange={(date) =>
                        this.setState({
                          frDate: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      value={this.frDate}
                      dateFormat="yyyy-MM-dd"
                    />
                    <DatePicker
                      className="form-control col-md-12"
                      selected={enDate}
                      onChange={(date) =>
                        this.setState({
                          enDate: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      value={this.enDate}
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                  <div className="row" style={{ marginTop: "2%" }}>
                    <button
                        style={{ marginLeft: "2%" }}
                        className="btn btn-success"
                        onClick={this.fetchDatas}
                    >
                      CARI DATA
                    </button>
                  </div>
                  <div className="row mt-1">
                    <div className="col">
                      <div className="custom-control custom-checkbox form-control-lg">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          onChange={(e) => {
                            this.checkHandler(e.target.checked);
                          }}
                          id="exampleCheck1"
                          // checked = {this.state.served}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="exampleCheck1"
                        >
                          tampilkan yang sudah dilayani
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-header border-0" />
                <TablePelayanan
                  headers={[
                    "No",
                    "Antrian",
                    "Ruangan",
                    "Tgl Masuk",
                    "No MR",
                    "No Bpjs",
                    "NIK",
                    "Nama",
                    "Sex",
                    "tgl lahir",
                    "Aksi",
                  ]}
                  datas={this.state.datas}
                  isLoading={isLoading}
                  listsPerPage={10}
                  history={this.props.history}
                  keyword={{
                    keyword: this.state.keyword,
                    frDate: this.state.frDate,
                    enDate: this.state.enDate,
                    limit: this.state.limit,
                    sort: this.state.sort,
                    served: this.state.served,
                    parent: this.state.parent,
                    has_room: 1
                  }}
                  refRoom={this.state.room}
                  reloadData={this.fetchDatas}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Pelayanan;

const dummy = JSON.parse(`
{
    "code": 200,
    "status": "Success",
    "data": {
        "current_page": 1,
        "data": [
            {
                "id": 8437,
                "parent_id": 1,
                "patient_id": 1443,
                "family_folder": "1",
                "family_relationship_id": 1,
                "paramedic_id": 1,
                "user_id": 1,
                "payment_type_id": 1,
                "clinic_id": 1,
                "insurance_no": "1",
                "village_id": "3401010007",
                "previous_clinic_id": 1,
                "continue_id": 0,
                "continue_internal": 1,
                "served": true,
                "pcare_patient_code_provider": null,
                "admission_type_id": 1,
                "drug_taken": true,
                "specialis": 1,
                "visit_type": "1",
                "served_card": true,
                "clinic_group": "1",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "1",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": true,
                "statustracer": true,
                "ambulance": true,
                "log": false,
                "created_at": "2020-05-11 05:21:14",
                "updated_at": "2022-02-20 18:18:01",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": null,
                "prolanis": null,
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 191,
                "accident_id": null,
                "clinic_visit_type": null,
                "inpatient": {
                    "id": 7,
                    "visit_id": 8437,
                    "entry_icd_code": "",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2021-01-06",
                    "exit_date": "2022-02-20",
                    "served": true,
                    "created_at": "2022-02-06 14:26:22",
                    "updated_at": "2022-03-07 12:00:27",
                    "inpatient_continue_id": 0,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 22,
                            "inpatient_id": 7,
                            "dpjp_id": 3,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2021-01-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-03-07 12:00:26",
                            "updated_at": "2022-03-07 12:00:26",
                            "dpjp": {
                                "id": 3,
                                "name": "dr. Pudyastuti",
                                "username": "ngawen1",
                                "paramedic_type_id": "1",
                                "clinic_id": "1",
                                "nip": "19670913 200212 2 002",
                                "code_doctor_pcare": "97354",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3403140201",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": []
                        },
                        {
                            "id": 15,
                            "inpatient_id": 7,
                            "dpjp_id": 30,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2022-02-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-06 18:14:23",
                            "updated_at": "2022-02-06 18:14:23",
                            "dpjp": {
                                "id": 30,
                                "name": "Admin PKM Gamping 2",
                                "username": "gamping2",
                                "paramedic_type_id": "99",
                                "clinic_id": "1",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3404050202",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": [
                                {
                                    "id": 8,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-20 17:55:11",
                                    "updated_at": "2022-02-20 17:55:11",
                                    "diagnoses": [],
                                    "examinations": [
                                        {
                                            "id": 589859,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 8,
                                            "sistole": 77,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": true,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Budaya,Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-20 18:12:41",
                                            "updated_at": "2022-02-20 18:12:41",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "hey tayo"
                                        }
                                    ],
                                    "advices": [
                                        {
                                            "id": 790,
                                            "visit_id": 8437,
                                            "advice": "",
                                            "evaluation": "",
                                            "created_at": "2022-02-20 18:16:03",
                                            "updated_at": "2022-02-20 18:16:03",
                                            "visit_inpatient_detail_id": 8
                                        }
                                    ],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 443,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 8,
                                            "anamnese": "hehe",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-20 17:55:12",
                                            "updated_at": "2022-02-20 17:55:12",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 7,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-18 13:35:02",
                                    "updated_at": "2022-02-18 13:35:02",
                                    "diagnoses": [],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 442,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 7,
                                            "anamnese": "ngelu",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-18 13:35:02",
                                            "updated_at": "2022-02-18 13:35:02",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 5,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-13 19:25:48",
                                    "updated_at": "2022-02-13 19:25:48",
                                    "diagnoses": [
                                        {
                                            "id": 4306,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "H01",
                                            "icd_name": "Inflamasi kelopak mata lainnya",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:50:08",
                                            "updated_at": "2022-02-14 14:50:08",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4305,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "G01",
                                            "icd_name": "Meningitis pada penyakit-penyakit bakterial yang terklasifikasi ditempat lain",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:48:38",
                                            "updated_at": "2022-02-14 14:48:38",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4304,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "F01",
                                            "icd_name": "Demensia vaskular",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:26:08",
                                            "updated_at": "2022-02-14 14:26:08",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4303,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "E01",
                                            "icd_name": "Defisiensi iodin terkait kelainan tiroid dan kondisi-kondisi yang berhubungan",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:21:51",
                                            "updated_at": "2022-02-14 14:21:51",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4302,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "D01",
                                            "icd_name": "Karsinoma in situ pada organ pencernaan lain dan tidak terspesifikasi",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:18:26",
                                            "updated_at": "2022-02-14 14:18:26",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589839,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "sistole": 21,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": true,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-14 14:49:25",
                                            "updated_at": "2022-02-14 15:13:37",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "hey"
                                        }
                                    ],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 430,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "anamnese": "hehe",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 19:25:48",
                                            "updated_at": "2022-02-13 19:25:48",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 4,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-07 06:15:17",
                                    "updated_at": "2022-02-06 06:15:17",
                                    "diagnoses": [
                                        {
                                            "id": 4301,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "icd_code": "A02",
                                            "icd_name": "Infeksi salmonella lainnya",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 06:44:07",
                                            "updated_at": "2022-02-14 06:44:07",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4299,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "icd_code": "K01",
                                            "icd_name": "Gigi embed dan impak",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:17:02",
                                            "updated_at": "2022-02-13 22:17:02",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589837,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "sistole": 320,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": false,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-14 06:43:38",
                                            "updated_at": "2022-02-14 15:13:17",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "dua"
                                        }
                                    ],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 423,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "anamnese": "asala aja",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 18:40:02",
                                            "updated_at": "2022-02-14 06:43:10",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 3,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-06 06:15:17",
                                    "updated_at": "2022-02-06 06:15:17",
                                    "diagnoses": [
                                        {
                                            "id": 4300,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "icd_code": "C01",
                                            "icd_name": "Neoplasma ganas di bawah lidah",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:22:46",
                                            "updated_at": "2022-02-13 22:22:46",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4298,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "icd_code": "A01",
                                            "icd_name": "Demam tifoid dan paratifoid",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:16:17",
                                            "updated_at": "2022-02-13 22:16:17",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589836,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "sistole": 120,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 69,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": false,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Budaya,Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-13 21:17:46",
                                            "updated_at": "2022-02-13 22:22:40",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "awox"
                                        }
                                    ],
                                    "advices": [
                                        {
                                            "id": 788,
                                            "visit_id": 8437,
                                            "advice": "yoyitu",
                                            "evaluation": "hheeeww",
                                            "created_at": "2022-02-19 10:31:00",
                                            "updated_at": "2022-02-19 11:02:44",
                                            "visit_inpatient_detail_id": 3
                                        }
                                    ],
                                    "treatments": [
                                        {
                                            "id": 387,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 1,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:34:58",
                                            "updated_at": "2022-02-26 20:34:58",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 1,
                                                "treatment_category_id": 1,
                                                "name": "Rawat jalan umum",
                                                "price": "1000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        },
                                        {
                                            "id": 388,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 2,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:34:58",
                                            "updated_at": "2022-02-26 20:34:58",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 2,
                                                "treatment_category_id": 1,
                                                "name": "Surat keterangan dokter",
                                                "price": "20000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        },
                                        {
                                            "id": 386,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 1,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:30:28",
                                            "updated_at": "2022-02-26 20:30:28",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 1,
                                                "treatment_category_id": 1,
                                                "name": "Rawat jalan umum",
                                                "price": "1000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        }
                                    ],
                                    "anamneses": [
                                        {
                                            "id": 431,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "anamnese": "mosok rung ono? wes kan, awox awox",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 19:28:39",
                                            "updated_at": "2022-02-13 19:52:38",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": [
                                        {
                                            "id": 361,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "racikan yoyi",
                                            "combination_qty": "5.00",
                                            "signa_id": 1,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:11:24",
                                            "updated_at": "2022-02-26 20:11:24",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 552,
                                                    "prescribe_id": 361,
                                                    "drug_in_detail_id": 44,
                                                    "pcare_drug_code": 0,
                                                    "qty": "6.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:11:24",
                                                    "updated_at": "2022-02-26 20:11:24",
                                                    "drug_id": 31636,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 44,
                                                        "drug_in_id": 35,
                                                        "drug_id": 31636,
                                                        "batch_number": "C19825",
                                                        "expired_date": "2021-03-31",
                                                        "qty": "1000.00",
                                                        "price": "1190.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:25:38",
                                                        "updated_at": "2022-02-10 15:25:38",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "0",
                                                        "log": false,
                                                        "stock": "0.00",
                                                        "drug": {
                                                            "id": 31636,
                                                            "elog_code": "DRG000031636",
                                                            "generic_code": "8601",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                            "generic_name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                            "description": "SIRUP",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "120 MG/5 ML",
                                                            "group": "K",
                                                            "type": "",
                                                            "generic_type": "Generik ",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 31636,
                                                        "elog_code": "DRG000031636",
                                                        "generic_code": "8601",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                        "generic_name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                        "description": "SIRUP",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "120 MG/5 ML",
                                                        "group": "K",
                                                        "type": "",
                                                        "generic_type": "Generik ",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 1,
                                                "name": "3 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "3.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 359,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 2,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:08:29",
                                            "updated_at": "2022-02-26 20:08:29",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 550,
                                                    "prescribe_id": 359,
                                                    "drug_in_detail_id": 46,
                                                    "pcare_drug_code": 0,
                                                    "qty": "5.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:08:29",
                                                    "updated_at": "2022-02-26 20:08:29",
                                                    "drug_id": 31567,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 46,
                                                        "drug_in_id": 37,
                                                        "drug_id": 31567,
                                                        "batch_number": "123323213",
                                                        "expired_date": "2022-05-05",
                                                        "qty": "1200.00",
                                                        "price": "1000.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:25:38",
                                                        "updated_at": "2022-02-10 15:25:38",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "31.25.232",
                                                        "log": false,
                                                        "stock": "0.00",
                                                        "drug": {
                                                            "id": 31567,
                                                            "elog_code": "DRG000031567",
                                                            "generic_code": "8593",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "PARACETAMOL CAPTABS 500 MG",
                                                            "generic_name": "PARACETAMOL TABLET 500 MG",
                                                            "description": "CAPTABS",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "500 MG",
                                                            "group": "B",
                                                            "type": "",
                                                            "generic_type": "Generik ",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 31567,
                                                        "elog_code": "DRG000031567",
                                                        "generic_code": "8593",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "PARACETAMOL CAPTABS 500 MG",
                                                        "generic_name": "PARACETAMOL TABLET 500 MG",
                                                        "description": "CAPTABS",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "500 MG",
                                                        "group": "B",
                                                        "type": "",
                                                        "generic_type": "Generik ",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 2,
                                                "name": "2 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "2.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 360,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 3,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:08:29",
                                            "updated_at": "2022-02-26 20:08:29",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 551,
                                                    "prescribe_id": 360,
                                                    "drug_in_detail_id": 31,
                                                    "pcare_drug_code": 0,
                                                    "qty": "3.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:08:29",
                                                    "updated_at": "2022-02-26 20:08:29",
                                                    "drug_id": 8929,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 31,
                                                        "drug_in_id": 29,
                                                        "drug_id": 8929,
                                                        "batch_number": "-",
                                                        "expired_date": "2023-03-31",
                                                        "qty": "1000.00",
                                                        "price": "1000.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:23:29",
                                                        "updated_at": "2022-02-10 15:23:45",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "0",
                                                        "log": false,
                                                        "stock": "1000.00",
                                                        "drug": {
                                                            "id": 8929,
                                                            "elog_code": "DRG000008929",
                                                            "generic_code": "2884",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "CISAPRID TABLET 10  MG",
                                                            "generic_name": "CISAPRIDE TABLET 10  MG",
                                                            "description": "TABLET",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "10  MG",
                                                            "group": "K",
                                                            "type": "",
                                                            "generic_type": "Generik",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 8929,
                                                        "elog_code": "DRG000008929",
                                                        "generic_code": "2884",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "CISAPRID TABLET 10  MG",
                                                        "generic_name": "CISAPRIDE TABLET 10  MG",
                                                        "description": "TABLET",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "10  MG",
                                                        "group": "K",
                                                        "type": "",
                                                        "generic_type": "Generik",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 3,
                                                "name": "1 x Sehari",
                                                "active": true,
                                                "signa_1": "1.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 358,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 1,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-20 17:10:35",
                                            "updated_at": "2022-02-20 17:10:35",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 549,
                                                    "prescribe_id": 358,
                                                    "drug_in_detail_id": 48,
                                                    "pcare_drug_code": 0,
                                                    "qty": "10.00",
                                                    "log": false,
                                                    "created_at": "2022-02-20 17:10:35",
                                                    "updated_at": "2022-02-20 17:10:35",
                                                    "drug_id": 86760,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 48,
                                                        "drug_in_id": 39,
                                                        "drug_id": 86760,
                                                        "batch_number": "170720",
                                                        "expired_date": "2022-06-01",
                                                        "qty": "1000.00",
                                                        "price": "137.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-18 20:45:52",
                                                        "updated_at": "2022-02-18 20:46:33",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "22.12.2017A",
                                                        "log": false,
                                                        "stock": "1000.00",
                                                        "drug": {
                                                            "id": 86760,
                                                            "elog_code": "MDVx042485",
                                                            "generic_code": "12754",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "AXIMED ALKOHOL PREP PAD SWAB 70%",
                                                            "generic_name": "",
                                                            "description": "SWAB",
                                                            "clinical_unit": "PIECES",
                                                            "unit": "",
                                                            "strength": "70%",
                                                            "group": "",
                                                            "type": "",
                                                            "generic_type": "Generik",
                                                            "category": "BMHP",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 86760,
                                                        "elog_code": "MDVx042485",
                                                        "generic_code": "12754",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "AXIMED ALKOHOL PREP PAD SWAB 70%",
                                                        "generic_name": "",
                                                        "description": "SWAB",
                                                        "clinical_unit": "PIECES",
                                                        "unit": "",
                                                        "strength": "70%",
                                                        "group": "",
                                                        "type": "",
                                                        "generic_type": "Generik",
                                                        "category": "BMHP",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 1,
                                                "name": "3 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "3.00",
                                                "signa_2": "1.00"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "patients": {
                    "id": 1443,
                    "nik": "0000000000000001",
                    "name": "Pasien",
                    "last_name": "Sm 1 Pasien",
                    "sex": 1,
                    "parent_name": "Mulyanto",
                    "birth_place": "Sleman",
                    "birth_date": "1994-07-23",
                    "address": "Griya Saka Permai, Sleman, DIY",
                    "village_id": 3401010007,
                    "education_id": 2,
                    "job_id": 2,
                    "religion_id": 1,
                    "marital_status_id": 1,
                    "contact": "6208212412412",
                    "photo": "asd",
                    "flag": true,
                    "rekam_medis_flags": true,
                    "user_id": 59,
                    "created_at": "2020-05-11 05:21:14",
                    "updated_at": "2020-10-19 15:44:39",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": null,
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [
                        {
                            "id": 55,
                            "patient_id": 1443,
                            "explanation": "makan belalang",
                            "detail_id": 2,
                            "user_id": 59,
                            "log": false,
                            "created_at": "2020-10-19 12:39:31",
                            "updated_at": "2020-10-19 12:39:31",
                            "detail": {
                                "id": 2,
                                "pcare_code": 1,
                                "type_id": 1,
                                "name": "Makanan Lain",
                                "type": {
                                    "id": 1,
                                    "pcare_code": 1,
                                    "name": "Makanan"
                                }
                            }
                        }
                    ],
                    "job": {
                        "id": 2,
                        "name": "TNI/ABRI/POLRI",
                        "active": true,
                        "ptm": "TNI/POLRI"
                    }
                },
                "examinations": [
                    {
                        "id": 589859,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 8,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-20 18:12:41",
                        "updated_at": "2022-02-20 18:12:41",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589858,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-20 17:55:28",
                        "updated_at": "2022-02-20 17:55:28",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589857,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-18 13:35:20",
                        "updated_at": "2022-02-18 13:36:42",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589839,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 5,
                        "sistole": 21,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 14:49:25",
                        "updated_at": "2022-02-14 15:13:37",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey"
                    },
                    {
                        "id": 589837,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 4,
                        "sistole": 320,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 06:43:38",
                        "updated_at": "2022-02-14 15:13:17",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "dua"
                    },
                    {
                        "id": 589840,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 69,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 15:09:20",
                        "updated_at": "2022-02-14 15:09:20",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 589838,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 20,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 07:41:16",
                        "updated_at": "2022-02-14 07:41:16",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 589836,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 3,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 69,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-13 21:17:46",
                        "updated_at": "2022-02-13 22:22:40",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 8428,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 72,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2020-05-11 05:21:14",
                        "updated_at": "2022-02-13 21:06:27",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": {
                    "id": 790,
                    "visit_id": 8437,
                    "advice": "",
                    "evaluation": "",
                    "created_at": "2022-02-20 18:16:03",
                    "updated_at": "2022-02-20 18:16:03",
                    "visit_inpatient_detail_id": 8
                }
            },
            {
                "id": 8437,
                "parent_id": 1,
                "patient_id": 1443,
                "family_folder": "1",
                "family_relationship_id": 1,
                "paramedic_id": 1,
                "user_id": 1,
                "payment_type_id": 1,
                "clinic_id": 1,
                "insurance_no": "1",
                "village_id": "3401010007",
                "previous_clinic_id": 1,
                "continue_id": 0,
                "continue_internal": 1,
                "served": true,
                "pcare_patient_code_provider": null,
                "admission_type_id": 1,
                "drug_taken": true,
                "specialis": 1,
                "visit_type": "1",
                "served_card": true,
                "clinic_group": "1",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "1",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": true,
                "statustracer": true,
                "ambulance": true,
                "log": false,
                "created_at": "2020-05-11 05:21:14",
                "updated_at": "2022-02-20 18:18:01",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": null,
                "prolanis": null,
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 191,
                "accident_id": null,
                "clinic_visit_type": null,
                "inpatient": {
                    "id": 7,
                    "visit_id": 8437,
                    "entry_icd_code": "",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2021-01-06",
                    "exit_date": "2022-02-20",
                    "served": true,
                    "created_at": "2022-02-06 14:26:22",
                    "updated_at": "2022-03-07 12:00:27",
                    "inpatient_continue_id": 0,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 22,
                            "inpatient_id": 7,
                            "dpjp_id": 3,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2021-01-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-03-07 12:00:26",
                            "updated_at": "2022-03-07 12:00:26",
                            "dpjp": {
                                "id": 3,
                                "name": "dr. Pudyastuti",
                                "username": "ngawen1",
                                "paramedic_type_id": "1",
                                "clinic_id": "1",
                                "nip": "19670913 200212 2 002",
                                "code_doctor_pcare": "97354",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3403140201",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": []
                        },
                        {
                            "id": 15,
                            "inpatient_id": 7,
                            "dpjp_id": 30,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2022-02-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-06 18:14:23",
                            "updated_at": "2022-02-06 18:14:23",
                            "dpjp": {
                                "id": 30,
                                "name": "Admin PKM Gamping 2",
                                "username": "gamping2",
                                "paramedic_type_id": "99",
                                "clinic_id": "1",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3404050202",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": [
                                {
                                    "id": 8,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-20 17:55:11",
                                    "updated_at": "2022-02-20 17:55:11",
                                    "diagnoses": [],
                                    "examinations": [
                                        {
                                            "id": 589859,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 8,
                                            "sistole": 77,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": true,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Budaya,Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-20 18:12:41",
                                            "updated_at": "2022-02-20 18:12:41",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "hey tayo"
                                        }
                                    ],
                                    "advices": [
                                        {
                                            "id": 790,
                                            "visit_id": 8437,
                                            "advice": "",
                                            "evaluation": "",
                                            "created_at": "2022-02-20 18:16:03",
                                            "updated_at": "2022-02-20 18:16:03",
                                            "visit_inpatient_detail_id": 8
                                        }
                                    ],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 443,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 8,
                                            "anamnese": "hehe",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-20 17:55:12",
                                            "updated_at": "2022-02-20 17:55:12",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 7,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-18 13:35:02",
                                    "updated_at": "2022-02-18 13:35:02",
                                    "diagnoses": [],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 442,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 7,
                                            "anamnese": "ngelu",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-18 13:35:02",
                                            "updated_at": "2022-02-18 13:35:02",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 5,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-13 19:25:48",
                                    "updated_at": "2022-02-13 19:25:48",
                                    "diagnoses": [
                                        {
                                            "id": 4306,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "H01",
                                            "icd_name": "Inflamasi kelopak mata lainnya",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:50:08",
                                            "updated_at": "2022-02-14 14:50:08",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4305,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "G01",
                                            "icd_name": "Meningitis pada penyakit-penyakit bakterial yang terklasifikasi ditempat lain",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:48:38",
                                            "updated_at": "2022-02-14 14:48:38",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4304,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "F01",
                                            "icd_name": "Demensia vaskular",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:26:08",
                                            "updated_at": "2022-02-14 14:26:08",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4303,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "E01",
                                            "icd_name": "Defisiensi iodin terkait kelainan tiroid dan kondisi-kondisi yang berhubungan",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:21:51",
                                            "updated_at": "2022-02-14 14:21:51",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4302,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "icd_code": "D01",
                                            "icd_name": "Karsinoma in situ pada organ pencernaan lain dan tidak terspesifikasi",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 14:18:26",
                                            "updated_at": "2022-02-14 14:18:26",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589839,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "sistole": 21,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": true,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-14 14:49:25",
                                            "updated_at": "2022-02-14 15:13:37",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "hey"
                                        }
                                    ],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 430,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 5,
                                            "anamnese": "hehe",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 19:25:48",
                                            "updated_at": "2022-02-13 19:25:48",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 4,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-07 06:15:17",
                                    "updated_at": "2022-02-06 06:15:17",
                                    "diagnoses": [
                                        {
                                            "id": 4301,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "icd_code": "A02",
                                            "icd_name": "Infeksi salmonella lainnya",
                                            "explanation": "",
                                            "date": "2022-02-14",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-14 06:44:07",
                                            "updated_at": "2022-02-14 06:44:07",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4299,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "icd_code": "K01",
                                            "icd_name": "Gigi embed dan impak",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:17:02",
                                            "updated_at": "2022-02-13 22:17:02",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589837,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "sistole": 320,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 75,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": false,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-14 06:43:38",
                                            "updated_at": "2022-02-14 15:13:17",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "dua"
                                        }
                                    ],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 423,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 4,
                                            "anamnese": "asala aja",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 18:40:02",
                                            "updated_at": "2022-02-14 06:43:10",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 3,
                                    "inpatient_room_id": 15,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-06 06:15:17",
                                    "updated_at": "2022-02-06 06:15:17",
                                    "diagnoses": [
                                        {
                                            "id": 4300,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "icd_code": "C01",
                                            "icd_name": "Neoplasma ganas di bawah lidah",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:22:46",
                                            "updated_at": "2022-02-13 22:22:46",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4298,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "icd_code": "A01",
                                            "icd_name": "Demam tifoid dan paratifoid",
                                            "explanation": "",
                                            "date": "2022-02-13",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-13 22:16:17",
                                            "updated_at": "2022-02-13 22:16:17",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [
                                        {
                                            "id": 589836,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "sistole": 120,
                                            "diastole": 80,
                                            "temperature": "36.00",
                                            "pulse": 69,
                                            "physic_anamnese": "0",
                                            "respiration": "16.00",
                                            "weight": "60.00",
                                            "height": "169.00",
                                            "abdominal_circumference": "120.00",
                                            "blood_type_id": 3,
                                            "odontogram_kode": "0",
                                            "gizi": "0",
                                            "oclusi": "Normal-Bite",
                                            "torus_palat": "Tidak-Ada",
                                            "palatum": "Dalam",
                                            "supernumery_teeth": "Tidak-Ada",
                                            "ada_supernumery_teeth": "0",
                                            "diastema": "Tidak-Ada",
                                            "ada_diastema": "0",
                                            "anomali_teeth": "Tidak-Ada",
                                            "ada_anomali_teeth": "0",
                                            "other_sign": "0",
                                            "hypertensi": false,
                                            "jantung": false,
                                            "asthma": false,
                                            "dm": false,
                                            "drug_alergy": false,
                                            "other_sick_history": "0",
                                            "eo_face": "Tidak-Ada-Kelainan",
                                            "eo_kel_limfe": "Teraba",
                                            "eo_others": "0",
                                            "io_mukosa_gingiva": "0",
                                            "io_palatum": "0",
                                            "io_gigi": "0",
                                            "teeth_ce": false,
                                            "teeth_ce_plus": "0",
                                            "teeth_sondasi": false,
                                            "teeth_sondasi_plus": "0",
                                            "teeth_perkusi": false,
                                            "teeth_perkusi_plus": "0",
                                            "teeth_palpasi": false,
                                            "teeth_palpasi_plus": "0",
                                            "log": false,
                                            "smoke": false,
                                            "spo2": "0",
                                            "kepala": "-",
                                            "mata": "-",
                                            "hidung": "-",
                                            "telinga": "-",
                                            "mulut": "-",
                                            "leher": "-",
                                            "dada": "-",
                                            "punggung": "-",
                                            "cp": "-",
                                            "perut": "-",
                                            "hl": "0",
                                            "kelamin": "0",
                                            "ex_atas": "0",
                                            "ex_bawah": "0",
                                            "gcs_e": 0,
                                            "gcs_v": 0,
                                            "gcs_m": 0,
                                            "hambatan": "Budaya,Bahasa",
                                            "kecelakaan": "0",
                                            "created_at": "2022-02-13 21:17:46",
                                            "updated_at": "2022-02-13 22:22:40",
                                            "head_circumference": "120.00",
                                            "diagnostic_narativ": "awox"
                                        }
                                    ],
                                    "advices": [
                                        {
                                            "id": 788,
                                            "visit_id": 8437,
                                            "advice": "yoyitu",
                                            "evaluation": "hheeeww",
                                            "created_at": "2022-02-19 10:31:00",
                                            "updated_at": "2022-02-19 11:02:44",
                                            "visit_inpatient_detail_id": 3
                                        }
                                    ],
                                    "treatments": [
                                        {
                                            "id": 387,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 1,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:34:58",
                                            "updated_at": "2022-02-26 20:34:58",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 1,
                                                "treatment_category_id": 1,
                                                "name": "Rawat jalan umum",
                                                "price": "1000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        },
                                        {
                                            "id": 388,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 2,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:34:58",
                                            "updated_at": "2022-02-26 20:34:58",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 2,
                                                "treatment_category_id": 1,
                                                "name": "Surat keterangan dokter",
                                                "price": "20000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        },
                                        {
                                            "id": 386,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "treatment_id": 1,
                                            "pcare_treatment_code": null,
                                            "log": false,
                                            "created_at": "2022-02-26 20:30:28",
                                            "updated_at": "2022-02-26 20:30:28",
                                            "import_log": 1,
                                            "user_id": 1,
                                            "treatment": {
                                                "id": 1,
                                                "treatment_category_id": 1,
                                                "name": "Rawat jalan umum",
                                                "price": "1000.00",
                                                "pcare_code": null,
                                                "status": true
                                            }
                                        }
                                    ],
                                    "anamneses": [
                                        {
                                            "id": 431,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "anamnese": "mosok rung ono? wes kan, awox awox",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-13 19:28:39",
                                            "updated_at": "2022-02-13 19:52:38",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": [
                                        {
                                            "id": 361,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "racikan yoyi",
                                            "combination_qty": "5.00",
                                            "signa_id": 1,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:11:24",
                                            "updated_at": "2022-02-26 20:11:24",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 552,
                                                    "prescribe_id": 361,
                                                    "drug_in_detail_id": 44,
                                                    "pcare_drug_code": 0,
                                                    "qty": "6.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:11:24",
                                                    "updated_at": "2022-02-26 20:11:24",
                                                    "drug_id": 31636,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 44,
                                                        "drug_in_id": 35,
                                                        "drug_id": 31636,
                                                        "batch_number": "C19825",
                                                        "expired_date": "2021-03-31",
                                                        "qty": "1000.00",
                                                        "price": "1190.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:25:38",
                                                        "updated_at": "2022-02-10 15:25:38",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "0",
                                                        "log": false,
                                                        "stock": "0.00",
                                                        "drug": {
                                                            "id": 31636,
                                                            "elog_code": "DRG000031636",
                                                            "generic_code": "8601",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                            "generic_name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                            "description": "SIRUP",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "120 MG/5 ML",
                                                            "group": "K",
                                                            "type": "",
                                                            "generic_type": "Generik ",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 31636,
                                                        "elog_code": "DRG000031636",
                                                        "generic_code": "8601",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                        "generic_name": "PARACETAMOL SIRUP 120 MG/5 ML",
                                                        "description": "SIRUP",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "120 MG/5 ML",
                                                        "group": "K",
                                                        "type": "",
                                                        "generic_type": "Generik ",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 1,
                                                "name": "3 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "3.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 359,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 2,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:08:29",
                                            "updated_at": "2022-02-26 20:08:29",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 550,
                                                    "prescribe_id": 359,
                                                    "drug_in_detail_id": 46,
                                                    "pcare_drug_code": 0,
                                                    "qty": "5.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:08:29",
                                                    "updated_at": "2022-02-26 20:08:29",
                                                    "drug_id": 31567,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 46,
                                                        "drug_in_id": 37,
                                                        "drug_id": 31567,
                                                        "batch_number": "123323213",
                                                        "expired_date": "2022-05-05",
                                                        "qty": "1200.00",
                                                        "price": "1000.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:25:38",
                                                        "updated_at": "2022-02-10 15:25:38",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "31.25.232",
                                                        "log": false,
                                                        "stock": "0.00",
                                                        "drug": {
                                                            "id": 31567,
                                                            "elog_code": "DRG000031567",
                                                            "generic_code": "8593",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "PARACETAMOL CAPTABS 500 MG",
                                                            "generic_name": "PARACETAMOL TABLET 500 MG",
                                                            "description": "CAPTABS",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "500 MG",
                                                            "group": "B",
                                                            "type": "",
                                                            "generic_type": "Generik ",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 31567,
                                                        "elog_code": "DRG000031567",
                                                        "generic_code": "8593",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "PARACETAMOL CAPTABS 500 MG",
                                                        "generic_name": "PARACETAMOL TABLET 500 MG",
                                                        "description": "CAPTABS",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "500 MG",
                                                        "group": "B",
                                                        "type": "",
                                                        "generic_type": "Generik ",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 2,
                                                "name": "2 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "2.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 360,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 3,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-26 20:08:29",
                                            "updated_at": "2022-02-26 20:08:29",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 551,
                                                    "prescribe_id": 360,
                                                    "drug_in_detail_id": 31,
                                                    "pcare_drug_code": 0,
                                                    "qty": "3.00",
                                                    "log": false,
                                                    "created_at": "2022-02-26 20:08:29",
                                                    "updated_at": "2022-02-26 20:08:29",
                                                    "drug_id": 8929,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 31,
                                                        "drug_in_id": 29,
                                                        "drug_id": 8929,
                                                        "batch_number": "-",
                                                        "expired_date": "2023-03-31",
                                                        "qty": "1000.00",
                                                        "price": "1000.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-10 15:23:29",
                                                        "updated_at": "2022-02-10 15:23:45",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "0",
                                                        "log": false,
                                                        "stock": "1000.00",
                                                        "drug": {
                                                            "id": 8929,
                                                            "elog_code": "DRG000008929",
                                                            "generic_code": "2884",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "CISAPRID TABLET 10  MG",
                                                            "generic_name": "CISAPRIDE TABLET 10  MG",
                                                            "description": "TABLET",
                                                            "clinical_unit": "",
                                                            "unit": "",
                                                            "strength": "10  MG",
                                                            "group": "K",
                                                            "type": "",
                                                            "generic_type": "Generik",
                                                            "category": "OBAT",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 8929,
                                                        "elog_code": "DRG000008929",
                                                        "generic_code": "2884",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "CISAPRID TABLET 10  MG",
                                                        "generic_name": "CISAPRIDE TABLET 10  MG",
                                                        "description": "TABLET",
                                                        "clinical_unit": "",
                                                        "unit": "",
                                                        "strength": "10  MG",
                                                        "group": "K",
                                                        "type": "",
                                                        "generic_type": "Generik",
                                                        "category": "OBAT",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 3,
                                                "name": "1 x Sehari",
                                                "active": true,
                                                "signa_1": "1.00",
                                                "signa_2": "1.00"
                                            }
                                        },
                                        {
                                            "id": 358,
                                            "visit_id": 8437,
                                            "visit_inpatient_detail_id": 3,
                                            "pcare_receipt_code": null,
                                            "combination_name": "",
                                            "combination_qty": "0.00",
                                            "signa_id": 1,
                                            "drug_taken_date": null,
                                            "created_at": "2022-02-20 17:10:35",
                                            "updated_at": "2022-02-20 17:10:35",
                                            "log": false,
                                            "note": "",
                                            "import_log": 1,
                                            "details": [
                                                {
                                                    "id": 549,
                                                    "prescribe_id": 358,
                                                    "drug_in_detail_id": 48,
                                                    "pcare_drug_code": 0,
                                                    "qty": "10.00",
                                                    "log": false,
                                                    "created_at": "2022-02-20 17:10:35",
                                                    "updated_at": "2022-02-20 17:10:35",
                                                    "drug_id": 86760,
                                                    "import_log": 1,
                                                    "accepted": false,
                                                    "drug_in": {
                                                        "id": 48,
                                                        "drug_in_id": 39,
                                                        "drug_id": 86760,
                                                        "batch_number": "170720",
                                                        "expired_date": "2022-06-01",
                                                        "qty": "1000.00",
                                                        "price": "137.00",
                                                        "user_id": 1,
                                                        "created_at": "2022-02-18 20:45:52",
                                                        "updated_at": "2022-02-18 20:46:33",
                                                        "user_approval_id": 1,
                                                        "puskesmas_id": "P3403060111",
                                                        "invoice_number": "22.12.2017A",
                                                        "log": false,
                                                        "stock": "1000.00",
                                                        "drug": {
                                                            "id": 86760,
                                                            "elog_code": "MDVx042485",
                                                            "generic_code": "12754",
                                                            "pcare_code": "",
                                                            "barcode": "",
                                                            "name": "AXIMED ALKOHOL PREP PAD SWAB 70%",
                                                            "generic_name": "",
                                                            "description": "SWAB",
                                                            "clinical_unit": "PIECES",
                                                            "unit": "",
                                                            "strength": "70%",
                                                            "group": "",
                                                            "type": "",
                                                            "generic_type": "Generik",
                                                            "category": "BMHP",
                                                            "supplier_id": 1,
                                                            "usage": null,
                                                            "note": null,
                                                            "minimum_stock": 1,
                                                            "active": true
                                                        }
                                                    },
                                                    "drug": {
                                                        "id": 86760,
                                                        "elog_code": "MDVx042485",
                                                        "generic_code": "12754",
                                                        "pcare_code": "",
                                                        "barcode": "",
                                                        "name": "AXIMED ALKOHOL PREP PAD SWAB 70%",
                                                        "generic_name": "",
                                                        "description": "SWAB",
                                                        "clinical_unit": "PIECES",
                                                        "unit": "",
                                                        "strength": "70%",
                                                        "group": "",
                                                        "type": "",
                                                        "generic_type": "Generik",
                                                        "category": "BMHP",
                                                        "supplier_id": 1,
                                                        "usage": null,
                                                        "note": null,
                                                        "minimum_stock": 1,
                                                        "active": true
                                                    }
                                                }
                                            ],
                                            "signa": {
                                                "id": 1,
                                                "name": "3 x 1 Sehari",
                                                "active": true,
                                                "signa_1": "3.00",
                                                "signa_2": "1.00"
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                "patients": {
                    "id": 1443,
                    "nik": "0000000000000001",
                    "name": "Pasien",
                    "last_name": "Sm 1 Pasien",
                    "sex": 1,
                    "parent_name": "Mulyanto",
                    "birth_place": "Sleman",
                    "birth_date": "1994-07-23",
                    "address": "Griya Saka Permai, Sleman, DIY",
                    "village_id": 3401010007,
                    "education_id": 2,
                    "job_id": 2,
                    "religion_id": 1,
                    "marital_status_id": 1,
                    "contact": "6208212412412",
                    "photo": "asd",
                    "flag": true,
                    "rekam_medis_flags": true,
                    "user_id": 59,
                    "created_at": "2020-05-11 05:21:14",
                    "updated_at": "2020-10-19 15:44:39",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": null,
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [
                        {
                            "id": 55,
                            "patient_id": 1443,
                            "explanation": "makan belalang",
                            "detail_id": 2,
                            "user_id": 59,
                            "log": false,
                            "created_at": "2020-10-19 12:39:31",
                            "updated_at": "2020-10-19 12:39:31",
                            "detail": {
                                "id": 2,
                                "pcare_code": 1,
                                "type_id": 1,
                                "name": "Makanan Lain",
                                "type": {
                                    "id": 1,
                                    "pcare_code": 1,
                                    "name": "Makanan"
                                }
                            }
                        }
                    ],
                    "job": {
                        "id": 2,
                        "name": "TNI/ABRI/POLRI",
                        "active": true,
                        "ptm": "TNI/POLRI"
                    }
                },
                "examinations": [
                    {
                        "id": 589859,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 8,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-20 18:12:41",
                        "updated_at": "2022-02-20 18:12:41",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589858,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-20 17:55:28",
                        "updated_at": "2022-02-20 17:55:28",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589857,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 77,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-18 13:35:20",
                        "updated_at": "2022-02-18 13:36:42",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey tayo"
                    },
                    {
                        "id": 589839,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 5,
                        "sistole": 21,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 14:49:25",
                        "updated_at": "2022-02-14 15:13:37",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "hey"
                    },
                    {
                        "id": 589837,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 4,
                        "sistole": 320,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 06:43:38",
                        "updated_at": "2022-02-14 15:13:17",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "dua"
                    },
                    {
                        "id": 589840,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 69,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 15:09:20",
                        "updated_at": "2022-02-14 15:09:20",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 589838,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 20,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 75,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": true,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-14 07:41:16",
                        "updated_at": "2022-02-14 07:41:16",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 589836,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 3,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 69,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "120.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-13 21:17:46",
                        "updated_at": "2022-02-13 22:22:40",
                        "head_circumference": "120.00",
                        "diagnostic_narativ": "awox"
                    },
                    {
                        "id": 8428,
                        "visit_id": 8437,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 72,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 3,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2020-05-11 05:21:14",
                        "updated_at": "2022-02-13 21:06:27",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": {
                    "id": 790,
                    "visit_id": 8437,
                    "advice": "",
                    "evaluation": "",
                    "created_at": "2022-02-20 18:16:03",
                    "updated_at": "2022-02-20 18:16:03",
                    "visit_inpatient_detail_id": 8
                }
            },
            {
                "id": 143574,
                "parent_id": 0,
                "patient_id": 20496,
                "family_folder": "99000416",
                "family_relationship_id": 1,
                "paramedic_id": 50,
                "user_id": 1,
                "payment_type_id": 16,
                "clinic_id": 1,
                "insurance_no": "0000057768805",
                "village_id": "3404040002",
                "previous_clinic_id": 0,
                "continue_id": 2,
                "continue_internal": 1,
                "served": true,
                "pcare_patient_code_provider": "12020201",
                "admission_type_id": 7,
                "drug_taken": false,
                "specialis": 1,
                "visit_type": "3",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "1",
                "kd_tacc": "1",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": true,
                "statustracer": false,
                "ambulance": true,
                "log": false,
                "created_at": "2020-11-18 08:46:10",
                "updated_at": "2021-03-31 07:45:01",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": null,
                "prolanis": null,
                "paramedic_schedule_code": "",
                "queue_prescribe_id": null,
                "accident_id": null,
                "clinic_visit_type": null,
                "inpatient": {
                    "id": 9,
                    "visit_id": 143574,
                    "entry_icd_code": "",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2020-06-17",
                    "exit_date": null,
                    "served": false,
                    "created_at": "2020-06-17 14:49:40",
                    "updated_at": "2020-06-17 14:49:40",
                    "inpatient_continue_id": null,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 3,
                            "inpatient_id": 9,
                            "dpjp_id": 3,
                            "room_id": 4,
                            "user_id": 1,
                            "entry_date": "2020-06-17 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2020-06-17 14:49:40",
                            "updated_at": "2020-06-17 14:49:40",
                            "dpjp": {
                                "id": 3,
                                "name": "dr. Pudyastuti",
                                "username": "ngawen1",
                                "paramedic_type_id": "1",
                                "clinic_id": "1",
                                "nip": "19670913 200212 2 002",
                                "code_doctor_pcare": "97354",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3403140201",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 4,
                                "name": "Srikandi",
                                "bed": "0j",
                                "puskesmas_id": "P3403140201",
                                "room_class": ""
                            },
                            "details": []
                        }
                    ]
                },
                "patients": {
                    "id": 20496,
                    "nik": "3217060910920087",
                    "name": "Harry Sulistyo Tn",
                    "last_name": "",
                    "sex": 1,
                    "parent_name": "Harry Sulistyo Tn",
                    "birth_place": "-",
                    "birth_date": "1992-10-09",
                    "address": "Bukit Permata Cimahi F8 No 2 Rt 5/22, Cirame, Ngamprah, Bandung Barat, Jawa Barat / Tinggal Di Pande",
                    "village_id": 3404040002,
                    "education_id": 9,
                    "job_id": 1,
                    "religion_id": 9,
                    "marital_status_id": 2,
                    "contact": "085711181168",
                    "photo": "",
                    "flag": true,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": "2021-03-31 07:45:00",
                    "updated_at": "2021-03-31 07:45:00",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": null,
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [],
                    "job": {
                        "id": 1,
                        "name": "Pegawai Negeri Sipil",
                        "active": true,
                        "ptm": "PNS"
                    }
                },
                "examinations": [
                    {
                        "id": 120131,
                        "visit_id": 143574,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 88,
                        "physic_anamnese": "",
                        "respiration": "24.00",
                        "weight": "70.00",
                        "height": "178.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 0,
                        "odontogram_kode": "",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "",
                        "other_sign": "",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "",
                        "eo_others": "",
                        "io_mukosa_gingiva": "",
                        "io_palatum": "",
                        "io_gigi": "",
                        "teeth_ce": false,
                        "teeth_ce_plus": "",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "0",
                        "mata": "0",
                        "hidung": "0",
                        "telinga": "0",
                        "mulut": "0",
                        "leher": "0",
                        "dada": "0",
                        "punggung": "0",
                        "cp": "0",
                        "perut": "0",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 4,
                        "gcs_v": 5,
                        "gcs_m": 6,
                        "hambatan": "",
                        "kecelakaan": "",
                        "created_at": "2021-03-31 07:45:01",
                        "updated_at": "2021-03-31 07:45:01",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": null
                    }
                ],
                "advice": null
            },
            {
                "id": 613144,
                "parent_id": 0,
                "patient_id": 114523,
                "family_folder": "23",
                "family_relationship_id": 3,
                "paramedic_id": 1,
                "user_id": 1,
                "payment_type_id": 1,
                "clinic_id": 1,
                "insurance_no": "",
                "village_id": "3404130002",
                "previous_clinic_id": 0,
                "continue_id": 2,
                "continue_internal": 0,
                "served": true,
                "pcare_patient_code_provider": "",
                "admission_type_id": 5,
                "drug_taken": false,
                "specialis": 0,
                "visit_type": "1",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": false,
                "statustracer": false,
                "ambulance": false,
                "log": false,
                "created_at": "2021-11-03 10:04:58",
                "updated_at": "2021-11-08 15:50:03",
                "labs_flags": false,
                "domicile": "",
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": "",
                "prolanis": "",
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 80,
                "accident_id": null,
                "clinic_visit_type": null,
                "inpatient": {
                    "id": 20,
                    "visit_id": 613144,
                    "entry_icd_code": "K01",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2022-02-11",
                    "exit_date": null,
                    "served": false,
                    "created_at": "2022-02-07 15:37:31",
                    "updated_at": "2022-02-11 13:21:52",
                    "inpatient_continue_id": null,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 20,
                            "inpatient_id": 20,
                            "dpjp_id": 30,
                            "room_id": 11,
                            "user_id": 1,
                            "entry_date": "2022-02-11 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-11 13:21:52",
                            "updated_at": "2022-02-11 13:21:52",
                            "dpjp": {
                                "id": 30,
                                "name": "Admin PKM Gamping 2",
                                "username": "gamping2",
                                "paramedic_type_id": "99",
                                "clinic_id": "1",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3404050202",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 11,
                                "name": "Kumbang",
                                "bed": "1",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": []
                        }
                    ]
                },
                "patients": {
                    "id": 114523,
                    "nik": "1234567891124565",
                    "name": "Febry",
                    "last_name": "cek data 2",
                    "sex": 1,
                    "parent_name": "awae",
                    "birth_place": "Sleman",
                    "birth_date": "1997-04-22",
                    "address": "jl uji coba",
                    "village_id": 3404130002,
                    "education_id": 6,
                    "job_id": 1,
                    "religion_id": 2,
                    "marital_status_id": 2,
                    "contact": "6285278781999",
                    "photo": "-",
                    "flag": false,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": "2021-10-28 19:40:36",
                    "updated_at": "2021-12-09 09:58:25",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": "",
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [],
                    "job": {
                        "id": 1,
                        "name": "Pegawai Negeri Sipil",
                        "active": true,
                        "ptm": "PNS"
                    }
                },
                "examinations": [
                    {
                        "id": 589690,
                        "visit_id": 613144,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 70,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "45.00",
                        "height": "170.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2021-11-03 10:05:05",
                        "updated_at": "2021-11-08 15:49:58",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": {
                    "id": 703,
                    "visit_id": 613144,
                    "advice": "",
                    "evaluation": "",
                    "created_at": "2021-11-08 15:50:03",
                    "updated_at": "2021-11-08 15:50:03",
                    "visit_inpatient_detail_id": 0
                }
            },
            {
                "id": 267031,
                "parent_id": 446753,
                "patient_id": 38423,
                "family_folder": "02150047",
                "family_relationship_id": 4,
                "paramedic_id": 50,
                "user_id": 1,
                "payment_type_id": 5,
                "clinic_id": 218,
                "insurance_no": "0000655286837",
                "village_id": "3404040002",
                "previous_clinic_id": 0,
                "continue_id": 2,
                "continue_internal": 1,
                "served": true,
                "pcare_patient_code_provider": "12030302",
                "admission_type_id": 7,
                "drug_taken": false,
                "specialis": 1,
                "visit_type": "3",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "1",
                "kd_tacc": "1",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": true,
                "statustracer": false,
                "ambulance": true,
                "log": false,
                "created_at": "2020-10-22 09:00:01",
                "updated_at": "2021-03-31 08:31:12",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": null,
                "prolanis": null,
                "paramedic_schedule_code": "",
                "queue_prescribe_id": null,
                "accident_id": null,
                "clinic_visit_type": null,
                "inpatient": {
                    "id": 13,
                    "visit_id": 267031,
                    "entry_icd_code": null,
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2022-02-06",
                    "exit_date": null,
                    "served": false,
                    "created_at": "2022-02-06 21:11:17",
                    "updated_at": "2022-02-06 21:11:18",
                    "inpatient_continue_id": null,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 16,
                            "inpatient_id": 13,
                            "dpjp_id": 437,
                            "room_id": 11,
                            "user_id": 1,
                            "entry_date": "2022-02-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-06 21:14:10",
                            "updated_at": "2022-02-06 21:14:10",
                            "dpjp": {
                                "id": 437,
                                "name": "pendaftaran demo",
                                "username": "pdemo",
                                "paramedic_type_id": "2",
                                "clinic_id": "51",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 99,
                                "puskesmas_id": "P3403060111",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 11,
                                "name": "Kumbang",
                                "bed": "1",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": [
                                {
                                    "id": 2,
                                    "inpatient_room_id": 16,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-06 06:15:17",
                                    "updated_at": "2022-02-06 06:15:17",
                                    "diagnoses": [],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [],
                                    "prescribes": []
                                }
                            ]
                        }
                    ]
                },
                "patients": {
                    "id": 38423,
                    "nik": "",
                    "name": "Ayu Yuliana",
                    "last_name": "",
                    "sex": 2,
                    "parent_name": "Nasrun Aziz",
                    "birth_place": "Sleman",
                    "birth_date": "1992-07-08",
                    "address": "Krajan Rt 01/33",
                    "village_id": 3404040002,
                    "education_id": 9,
                    "job_id": 11,
                    "religion_id": 9,
                    "marital_status_id": 2,
                    "contact": "085799267081",
                    "photo": "",
                    "flag": false,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": "2021-03-31 08:31:11",
                    "updated_at": "2021-03-31 08:31:11",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": null,
                    "iks_flags": false,
                    "sexs": {
                        "id": 2,
                        "name": "Perempuan",
                        "active": true,
                        "ptm": "PEREMPUAN"
                    },
                    "allergies": [],
                    "job": {
                        "id": 11,
                        "name": "Lain-lain",
                        "active": true,
                        "ptm": "LAINNYA"
                    }
                },
                "examinations": [
                    {
                        "id": 243588,
                        "visit_id": 267031,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 0,
                        "diastole": 0,
                        "temperature": "0.00",
                        "pulse": 0,
                        "physic_anamnese": "0",
                        "respiration": "0.00",
                        "weight": "0.00",
                        "height": "0.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "",
                        "gizi": "0",
                        "oclusi": "",
                        "torus_palat": "",
                        "palatum": "0",
                        "supernumery_teeth": "",
                        "ada_supernumery_teeth": "0",
                        "diastema": "",
                        "ada_diastema": "0",
                        "anomali_teeth": "",
                        "ada_anomali_teeth": "0",
                        "other_sign": "",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": true,
                        "other_sick_history": "",
                        "eo_face": "",
                        "eo_kel_limfe": "",
                        "eo_others": "",
                        "io_mukosa_gingiva": "",
                        "io_palatum": "",
                        "io_gigi": "",
                        "teeth_ce": false,
                        "teeth_ce_plus": "",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "",
                        "log": true,
                        "smoke": true,
                        "spo2": "",
                        "kepala": "",
                        "mata": "",
                        "hidung": "",
                        "telinga": "",
                        "mulut": "",
                        "leher": "",
                        "dada": "",
                        "punggung": "",
                        "cp": "",
                        "perut": "",
                        "hl": "",
                        "kelamin": "",
                        "ex_atas": "",
                        "ex_bawah": "",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "",
                        "kecelakaan": "",
                        "created_at": "2021-03-31 08:31:12",
                        "updated_at": "2021-03-31 08:31:12",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": null
                    }
                ],
                "advice": null
            },
            {
                "id": 613276,
                "parent_id": 0,
                "patient_id": 113987,
                "family_folder": "1",
                "family_relationship_id": 1,
                "paramedic_id": 1,
                "user_id": 1,
                "payment_type_id": 1,
                "clinic_id": 1,
                "insurance_no": "",
                "village_id": "3403100003",
                "previous_clinic_id": 0,
                "continue_id": 2,
                "continue_internal": 0,
                "served": true,
                "pcare_patient_code_provider": "",
                "admission_type_id": 5,
                "drug_taken": false,
                "specialis": 0,
                "visit_type": "1",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": false,
                "statustracer": false,
                "ambulance": false,
                "log": false,
                "created_at": "2022-02-07 02:21:21",
                "updated_at": "2022-03-01 14:17:12",
                "labs_flags": false,
                "domicile": "",
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "10",
                "prb": "",
                "prolanis": "",
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 176,
                "accident_id": null,
                "clinic_visit_type": "lama",
                "inpatient": {
                    "id": 19,
                    "visit_id": 613276,
                    "entry_icd_code": "A01",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2022-02-06",
                    "exit_date": "2022-03-01",
                    "served": true,
                    "created_at": "2022-02-07 14:46:31",
                    "updated_at": "2022-03-01 14:17:11",
                    "inpatient_continue_id": 2,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": {
                        "id": 2,
                        "name": "Pulang Paksa",
                        "active": true
                    },
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 18,
                            "inpatient_id": 19,
                            "dpjp_id": 270,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2022-02-06 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-07 15:58:10",
                            "updated_at": "2022-02-07 15:58:10",
                            "dpjp": {
                                "id": 270,
                                "name": "Sri Nismala Dewi",
                                "username": "P3404110202_dewi_35",
                                "paramedic_type_id": "0",
                                "clinic_id": "0",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 4,
                                "puskesmas_id": "P3404110202",
                                "is_active": true,
                                "created_at": "2021-02-15 13:29:37",
                                "updated_at": "2021-02-15 13:29:37",
                                "old_id": 35,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": [
                                {
                                    "id": 10,
                                    "inpatient_room_id": 18,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-03-01 14:08:13",
                                    "updated_at": "2022-03-01 14:08:13",
                                    "diagnoses": [],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 445,
                                            "visit_id": 613276,
                                            "visit_inpatient_detail_id": 10,
                                            "anamnese": "ngelu mas",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-03-01 14:08:14",
                                            "updated_at": "2022-03-01 14:08:14",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                }
                            ]
                        }
                    ]
                },
                "patients": {
                    "id": 113987,
                    "nik": "9999999999999993",
                    "name": "data",
                    "last_name": "iks 3 -",
                    "sex": 1,
                    "parent_name": "-",
                    "birth_place": "-",
                    "birth_date": "1962-06-25",
                    "address": "-",
                    "village_id": 3403100003,
                    "education_id": 1,
                    "job_id": 11,
                    "religion_id": 1,
                    "marital_status_id": 1,
                    "contact": "620",
                    "photo": "-",
                    "flag": false,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": null,
                    "updated_at": "2022-02-07 14:21:27",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": "",
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [],
                    "job": {
                        "id": 11,
                        "name": "Lain-lain",
                        "active": true,
                        "ptm": "LAINNYA"
                    }
                },
                "examinations": [
                    {
                        "id": 589822,
                        "visit_id": 613276,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 70,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "56.00",
                        "height": "157.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2022-02-07 14:21:27",
                        "updated_at": "2022-03-01 14:09:15",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": "cerita aja"
                    },
                    {
                        "id": 589861,
                        "visit_id": 613276,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "37.00",
                        "pulse": 77,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "56.00",
                        "height": "157.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2022-03-01 14:08:38",
                        "updated_at": "2022-03-01 14:08:38",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": {
                    "id": 792,
                    "visit_id": 613276,
                    "advice": "madang ae mas",
                    "evaluation": "mbuh",
                    "created_at": "2022-03-01 14:17:10",
                    "updated_at": "2022-03-01 14:17:10",
                    "visit_inpatient_detail_id": 0
                }
            },
            {
                "id": 613293,
                "parent_id": 0,
                "patient_id": 113988,
                "family_folder": "333",
                "family_relationship_id": 1,
                "paramedic_id": 1,
                "user_id": 1,
                "payment_type_id": 12,
                "clinic_id": 10,
                "insurance_no": "666",
                "village_id": "3403100003",
                "previous_clinic_id": 1,
                "continue_id": 0,
                "continue_internal": null,
                "served": true,
                "pcare_patient_code_provider": "",
                "admission_type_id": 5,
                "drug_taken": false,
                "specialis": 0,
                "visit_type": "1",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": false,
                "statustracer": false,
                "ambulance": false,
                "log": false,
                "created_at": "2022-02-15 14:03:36",
                "updated_at": "2022-02-26 22:18:46",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "20",
                "prb": "",
                "prolanis": "",
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 187,
                "accident_id": null,
                "clinic_visit_type": "lama",
                "inpatient": {
                    "id": 21,
                    "visit_id": 613293,
                    "entry_icd_code": "B02",
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2022-02-15",
                    "exit_date": "2022-02-26",
                    "served": true,
                    "created_at": "2022-02-15 14:03:37",
                    "updated_at": "2022-02-26 22:18:46",
                    "inpatient_continue_id": 0,
                    "log": false,
                    "user_id": 1,
                    "users": {
                        "id": 1,
                        "name": "Demo Admin",
                        "username": "admindemo",
                        "paramedic_type_id": "99",
                        "clinic_id": "1",
                        "nip": "19780111 200501 2 008",
                        "code_doctor_pcare": "100555",
                        "medic_type": "1",
                        "role_id": 2,
                        "puskesmas_id": "P3403060111",
                        "is_active": true,
                        "created_at": null,
                        "updated_at": "2021-08-20 19:40:04",
                        "old_id": null,
                        "email": "",
                        "level": 1
                    },
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 21,
                            "inpatient_id": 21,
                            "dpjp_id": 30,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2022-02-15 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-15 14:17:53",
                            "updated_at": "2022-02-15 14:17:53",
                            "dpjp": {
                                "id": 30,
                                "name": "Admin PKM Gamping 2",
                                "username": "gamping2",
                                "paramedic_type_id": "99",
                                "clinic_id": "1",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3404050202",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": [
                                {
                                    "id": 9,
                                    "inpatient_room_id": 21,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-26 22:15:47",
                                    "updated_at": "2022-02-26 22:15:47",
                                    "diagnoses": [],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 444,
                                            "visit_id": 613293,
                                            "visit_inpatient_detail_id": 9,
                                            "anamnese": "ngeluh utang",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-26 22:15:48",
                                            "updated_at": "2022-02-26 22:15:48",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                },
                                {
                                    "id": 6,
                                    "inpatient_room_id": 21,
                                    "drug_taken": null,
                                    "user_id": 1,
                                    "log": false,
                                    "created_at": "2022-02-15 14:18:31",
                                    "updated_at": "2022-02-15 14:18:31",
                                    "diagnoses": [
                                        {
                                            "id": 4319,
                                            "visit_id": 613293,
                                            "visit_inpatient_detail_id": 6,
                                            "icd_code": "C01",
                                            "icd_name": "Neoplasma ganas di bawah lidah",
                                            "explanation": "",
                                            "date": "2022-02-26",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-26 21:44:45",
                                            "updated_at": "2022-02-26 21:44:45",
                                            "import_log": 1
                                        },
                                        {
                                            "id": 4318,
                                            "visit_id": 613293,
                                            "visit_inpatient_detail_id": 6,
                                            "icd_code": "B01.1",
                                            "icd_name": "Ensefalitis cacar air",
                                            "explanation": "",
                                            "date": "2022-02-26",
                                            "case": "new",
                                            "elemen_teeth": "0",
                                            "log": false,
                                            "examination_type_id": 0,
                                            "created_at": "2022-02-26 21:32:05",
                                            "updated_at": "2022-02-26 21:32:05",
                                            "import_log": 1
                                        }
                                    ],
                                    "examinations": [],
                                    "advices": [],
                                    "treatments": [],
                                    "anamneses": [
                                        {
                                            "id": 439,
                                            "visit_id": 613293,
                                            "visit_inpatient_detail_id": 6,
                                            "anamnese": "haha",
                                            "nursing_anamnese": "-",
                                            "treat": "-",
                                            "eval": "0",
                                            "created_at": "2022-02-15 14:18:31",
                                            "updated_at": "2022-02-15 14:18:31",
                                            "prognosis_id": 1
                                        }
                                    ],
                                    "prescribes": []
                                }
                            ]
                        }
                    ]
                },
                "patients": {
                    "id": 113988,
                    "nik": "9999999999999992",
                    "name": "data",
                    "last_name": "iks 2 -",
                    "sex": 1,
                    "parent_name": "-",
                    "birth_place": "-",
                    "birth_date": "1962-06-25",
                    "address": "-",
                    "village_id": 3403100003,
                    "education_id": 2,
                    "job_id": 2,
                    "religion_id": 2,
                    "marital_status_id": 1,
                    "contact": "620",
                    "photo": "-",
                    "flag": false,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": null,
                    "updated_at": "2022-02-15 14:02:58",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": "",
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [
                        {
                            "id": 81,
                            "patient_id": 113988,
                            "explanation": "s",
                            "detail_id": 2,
                            "user_id": 1,
                            "log": false,
                            "created_at": "2021-11-16 14:07:40",
                            "updated_at": "2021-11-16 14:07:40",
                            "detail": {
                                "id": 2,
                                "pcare_code": 1,
                                "type_id": 1,
                                "name": "Makanan Lain",
                                "type": {
                                    "id": 1,
                                    "pcare_code": 1,
                                    "name": "Makanan"
                                }
                            }
                        }
                    ],
                    "job": {
                        "id": 2,
                        "name": "TNI/ABRI/POLRI",
                        "active": true,
                        "ptm": "TNI/POLRI"
                    }
                },
                "examinations": [
                    {
                        "id": 589849,
                        "visit_id": 613293,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 129,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 79,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2022-02-15 14:18:52",
                        "updated_at": "2022-02-26 22:16:33",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": "cerita teyus"
                    },
                    {
                        "id": 589860,
                        "visit_id": 613293,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 121,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 71,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "Budaya,Bahasa",
                        "kecelakaan": "0",
                        "created_at": "2022-02-26 22:16:03",
                        "updated_at": "2022-02-26 22:16:03",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": "avv"
                    },
                    {
                        "id": 589848,
                        "visit_id": 613293,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 70,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "60.00",
                        "height": "169.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2022-02-15 14:03:37",
                        "updated_at": "2022-02-15 14:03:37",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": {
                    "id": 791,
                    "visit_id": 613293,
                    "advice": "cari pinjol aja",
                    "evaluation": "tidak lulus dong",
                    "created_at": "2022-02-26 22:18:45",
                    "updated_at": "2022-02-26 22:18:45",
                    "visit_inpatient_detail_id": 0
                }
            },
            {
                "id": 613279,
                "parent_id": 0,
                "patient_id": 113987,
                "family_folder": "1",
                "family_relationship_id": 1,
                "paramedic_id": null,
                "user_id": 1,
                "payment_type_id": 1,
                "clinic_id": 10,
                "insurance_no": "",
                "village_id": "3403100003",
                "previous_clinic_id": 1,
                "continue_id": 2,
                "continue_internal": null,
                "served": false,
                "pcare_patient_code_provider": "",
                "admission_type_id": 5,
                "drug_taken": false,
                "specialis": 0,
                "visit_type": "1",
                "served_card": false,
                "clinic_group": "0",
                "nurse_id": null,
                "kd_sadar": "01",
                "kd_tacc": "",
                "pcare_visit_number": null,
                "pcare_queue_number": null,
                "statuscall": false,
                "statustracer": false,
                "ambulance": false,
                "log": false,
                "created_at": "2022-02-07 14:37:29",
                "updated_at": "2022-02-07 14:37:29",
                "labs_flags": false,
                "domicile": null,
                "labs_served": false,
                "pcare_sick": true,
                "pcare_treatment_code": "20",
                "prb": "",
                "prolanis": "",
                "paramedic_schedule_code": "",
                "queue_prescribe_id": 176,
                "accident_id": null,
                "clinic_visit_type": "lama",
                "inpatient": {
                    "id": 17,
                    "visit_id": 613279,
                    "entry_icd_code": null,
                    "exit_icd_code": null,
                    "exit_condition_id": null,
                    "entry_date": "2022-02-07",
                    "exit_date": null,
                    "served": false,
                    "created_at": "2022-02-07 13:37:29",
                    "updated_at": "2022-02-07 13:37:29",
                    "inpatient_continue_id": null,
                    "log": false,
                    "user_id": null,
                    "users": null,
                    "continue": null,
                    "exit": null,
                    "inpatient_rooms": [
                        {
                            "id": 17,
                            "inpatient_id": 17,
                            "dpjp_id": 30,
                            "room_id": 10,
                            "user_id": 1,
                            "entry_date": "2022-02-07 00:00:00",
                            "exit_date": null,
                            "log": false,
                            "created_at": "2022-02-07 14:54:32",
                            "updated_at": "2022-02-07 14:54:32",
                            "dpjp": {
                                "id": 30,
                                "name": "Admin PKM Gamping 2",
                                "username": "gamping2",
                                "paramedic_type_id": "99",
                                "clinic_id": "1",
                                "nip": "-",
                                "code_doctor_pcare": "0",
                                "medic_type": "1",
                                "role_id": 2,
                                "puskesmas_id": "P3404050202",
                                "is_active": true,
                                "created_at": null,
                                "updated_at": null,
                                "old_id": null,
                                "email": null,
                                "level": 2
                            },
                            "room": {
                                "id": 10,
                                "name": "Kobra",
                                "bed": "0",
                                "puskesmas_id": "P3403060111",
                                "room_class": "VVIP"
                            },
                            "details": []
                        }
                    ]
                },
                "patients": {
                    "id": 113987,
                    "nik": "9999999999999993",
                    "name": "data",
                    "last_name": "iks 3 -",
                    "sex": 1,
                    "parent_name": "-",
                    "birth_place": "-",
                    "birth_date": "1962-06-25",
                    "address": "-",
                    "village_id": 3403100003,
                    "education_id": 1,
                    "job_id": 11,
                    "religion_id": 1,
                    "marital_status_id": 1,
                    "contact": "620",
                    "photo": "-",
                    "flag": false,
                    "rekam_medis_flags": false,
                    "user_id": 1,
                    "created_at": null,
                    "updated_at": "2022-02-07 14:21:27",
                    "kk": 0,
                    "sub_village_code": "",
                    "sub_village": "",
                    "email": null,
                    "status_in_pcare": "",
                    "iks_flags": false,
                    "sexs": {
                        "id": 1,
                        "name": "Laki-laki",
                        "active": true,
                        "ptm": "LAKI-LAKI"
                    },
                    "allergies": [],
                    "job": {
                        "id": 11,
                        "name": "Lain-lain",
                        "active": true,
                        "ptm": "LAINNYA"
                    }
                },
                "examinations": [
                    {
                        "id": 589825,
                        "visit_id": 613279,
                        "visit_inpatient_detail_id": 0,
                        "sistole": 120,
                        "diastole": 80,
                        "temperature": "36.00",
                        "pulse": 70,
                        "physic_anamnese": "0",
                        "respiration": "16.00",
                        "weight": "56.00",
                        "height": "157.00",
                        "abdominal_circumference": "0.00",
                        "blood_type_id": 1,
                        "odontogram_kode": "0",
                        "gizi": "0",
                        "oclusi": "Normal-Bite",
                        "torus_palat": "Tidak-Ada",
                        "palatum": "Dalam",
                        "supernumery_teeth": "Tidak-Ada",
                        "ada_supernumery_teeth": "0",
                        "diastema": "Tidak-Ada",
                        "ada_diastema": "0",
                        "anomali_teeth": "Tidak-Ada",
                        "ada_anomali_teeth": "0",
                        "other_sign": "0",
                        "hypertensi": false,
                        "jantung": false,
                        "asthma": false,
                        "dm": false,
                        "drug_alergy": false,
                        "other_sick_history": "0",
                        "eo_face": "Tidak-Ada-Kelainan",
                        "eo_kel_limfe": "Teraba",
                        "eo_others": "0",
                        "io_mukosa_gingiva": "0",
                        "io_palatum": "0",
                        "io_gigi": "0",
                        "teeth_ce": false,
                        "teeth_ce_plus": "0",
                        "teeth_sondasi": false,
                        "teeth_sondasi_plus": "0",
                        "teeth_perkusi": false,
                        "teeth_perkusi_plus": "0",
                        "teeth_palpasi": false,
                        "teeth_palpasi_plus": "0",
                        "log": false,
                        "smoke": false,
                        "spo2": "0",
                        "kepala": "-",
                        "mata": "-",
                        "hidung": "-",
                        "telinga": "-",
                        "mulut": "-",
                        "leher": "-",
                        "dada": "-",
                        "punggung": "-",
                        "cp": "-",
                        "perut": "-",
                        "hl": "0",
                        "kelamin": "0",
                        "ex_atas": "0",
                        "ex_bawah": "0",
                        "gcs_e": 0,
                        "gcs_v": 0,
                        "gcs_m": 0,
                        "hambatan": "0",
                        "kecelakaan": "0",
                        "created_at": "2022-02-07 14:37:29",
                        "updated_at": "2022-02-07 14:37:29",
                        "head_circumference": "0.00",
                        "diagnostic_narativ": ""
                    }
                ],
                "advice": null
            }
        ],
        "first_page_url": "http://localhost:8000/registration/inpatient/read?page=1",
        "from": 1,
        "last_page": 1,
        "last_page_url": "http://localhost:8000/registration/inpatient/read?page=1",
        "next_page_url": null,
        "path": "http://localhost:8000/registration/inpatient/read",
        "per_page": 25,
        "prev_page_url": null,
        "to": 8,
        "total": 8
    }
}
`)